/**
 * AngularJSApp
 * @todo Any angularJS requirements need to be removed so we can remove this file
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2024 Build Centrix
 */
'use strict';
import angular from 'angular';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngRoute from 'angular-route';
import ngSanitize from 'angular-sanitize';
import * as ngTouch from 'angular-touch';
import 'angular-ui-router';

// This module only initializes the routing with html5Mode
export const BlankApp = angular
  .module('blankApp', [ngCookies, ngResource, ngRoute, ngSanitize, ngTouch])
  .config(function ($locationProvider: { html5Mode: (arg0: boolean) => void }) {
    $locationProvider.html5Mode(true);
  });

// EOF
